/**
 * All the routes
 */
export const routes = {
	login: "auth/login",
	signup: "auth/signup",
    firebaseLogin: "auth/firebase-login",
	logout: "auth/logout",
	cartItems: "/cart/items",
	cartSync: "/cart/sync",
	customerProducts: "/customers/products",
	deliveryAddress: "/delivery-addresses",
	orders: "/orders",
	orderItems: "/order-items",
	// Upload a file for a choice_type = file Feature when adding it to
	// cart (e.g. a prescription) - see ViewProduct.js's "file" case.
	featureFile: (featureId) => `/features/${featureId}/file`,
	// View (decrypt + stream) a file already attached to a placed
	// order's item feature - see OrderTracking's file-view modal.
	orderItemFeatureFile: (orderItemFeatureId) => `/order-item-features/${orderItemFeatureId}/file`,
	pendingBusinessRatings: "/orders/pending-business-ratings",
	payments: "/payments",
	users: "/users",
	userStats: "/users/stats",
	paymentRequests: "/payment-requests",
	reviews: "/reviews",
	capaPurchases: "/capa-purchases",
	aiCreditPurchases: "/ai-credit-purchases",
	voiceOrderSessions: "/ai/voice-orders/sessions",
	orderPaymentSurpluses: "/order-payment-surpluses",
	settings: "/user-settings",
	awards: "/awards",
	transfers: "/transfers",
	follows: "/follows",
	businesses: "/companies",
	comments: "/comments",
	mentions: "/mentions",
	deliverers: "/deliverers",
	errands: "/errands",
	subscriptions: "/subscriptions",
	companyBookmarks: "/company-bookmarks",
	featureAnnouncements: "/feature-announcements",
};